import { createReducer, on } from '@ngrx/store';
import * as LocationHistoryActions from '../actions/location-history.actions';
import {
  LocationHistory,
  LocationHistoryStats,
} from '../../services/location-history.service';

export const locationHistoryFeatureKey = 'locationHistory';

export interface State {
  locationHistoryList: LocationHistory[];
  locationHistoryStats: LocationHistoryStats[];
  currentVehicleHistory: LocationHistory[];
  loading: boolean;
}

export const initialState: State = {
  locationHistoryList: [],
  locationHistoryStats: [],
  currentVehicleHistory: [],
  loading: false,
};

export const reducer = createReducer(
  initialState,
  on(LocationHistoryActions.loadLocationHistory, (state) => ({
    ...state,
    loading: true,
  })),
  on(LocationHistoryActions.loadLocationHistorySuccess, (state, action) => ({
    ...state,
    loading: false,
    locationHistoryList: action.locationHistoryList,
  })),
  on(LocationHistoryActions.loadLocationHistoryStats, (state) => ({
    ...state,
    loading: true,
  })),
  on(
    LocationHistoryActions.loadLocationHistoryStatsSuccess,
    (state, action) => ({
      ...state,
      loading: false,
      locationHistoryStats: action.payload,
    }),
  ),
  on(
    LocationHistoryActions.getCurrentVehicleHistorySuccess,
    (state, action) => ({
      ...state,
      loading: false,
      currentVehicleHistory: action.payload,
    }),
  ),
  on(LocationHistoryActions.loadLocationHistoryFailure, (state) => ({
    ...state,
    loading: false,
  })),
);

export const getLocationHistoryList = (state: State) =>
  state.locationHistoryList;
export const getLocationHistoryLoading = (state: State) => state.loading;
export const getLocationHistoryStats = (state: State) =>
  state.locationHistoryStats;
export const getCurrentVehicleHistory = (state: State) =>
  state.currentVehicleHistory;
